//* Libraries imports
import { AlertTriangle } from "lucide-react";

type DeleteReceiptModalProps = {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeleteReceiptModal({
  visible,
  onCancel,
  onConfirm,
}: DeleteReceiptModalProps) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 p-4 animate-in fade-in duration-200">
      <div className="bg-clarofrente-01 w-full max-w-xs rounded-2xl p-6 flex flex-col items-center gap-6 shadow-xl">
        <div className="size-20 bg-clarofundo-01 rounded-xl flex items-center justify-center">
          <AlertTriangle
            size={32}
            className="text-[#EF4444]"
            strokeWidth={2.5}
          />
        </div>

        <div className="flex flex-col items-center gap-3 w-full">
          <h3 className="text-center text-clarotextos-01 text-sm font-medium leading-relaxed">
            Deseja realmente excluir
            <br />
            este comprovante?
          </h3>
          <p className="text-center text-clarotextos-02 text-sm font-medium leading-relaxed">
            Esta ação não pode ser desfeita.
          </p>
        </div>

        <div className="flex flex-row items-center gap-3 w-full">
          <button
            onClick={onCancel}
            className="flex-1 h-11 bg-clarofundo-01 rounded-xl border border-clarobordas-01 text-clarotextos-01 text-sm font-bold hover:bg-[#EAEAEA] transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 h-11 bg-[#EF4444] rounded-xl text-clarofrente-01 text-sm font-bold hover:bg-[#DC2626] transition-colors"
          >
            Excluir
          </button>
        </div>
      </div>
    </div>
  );
}
